import { Routes, Route, Navigate } from 'react-router-dom';
import { OrgProvider } from './org/OrgContext';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import ChangePassword from './pages/ChangePassword';

import Header from './components/Header';
import OrgPicker from './org/OrgPicker';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import History from './pages/History';
import GfmDeliveries from './pages/gfmDeliveries';
import GfmOrderBuilder from './pages/gfmOrderBuilder';

// Assets
import Assets from './pages/Assets';
import Tickets from './pages/Tickets';

// NEW: GPM pages
import GpmInventory from './pages/gpmInventory';
import GpmHistory from './pages/gpmHistory';
import Teams from './pages/Teams';
import Services from './pages/Services';
import Keys from './pages/Keys';
import GpmDeliveries from './pages/gpmDeliveries';
import GpmScheduleDelivery from './pages/gpmOrderBuilder';

// Fleet pages
import Vehicles from './pages/Vehicles';
import FleetChecks from './pages/fleetChecks';
import FleetChecksList from './pages/fleetChecksList';

// Admin
import AdminUsers from './pages/AdminUsers';

export default function App(){
  return (
    <OrgProvider>
      <AuthProvider>
        <Header/>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login/>} />

          {/* Choose division AFTER login */}
          <Route element={<ProtectedRoute/>}>
            <Route path="/choose" element={<OrgPicker/>} />
          </Route>

          {/* App — requires login AND selected org */}
          <Route element={<ProtectedRoute/>}>
            <Route path="/dashboard" element={<Dashboard/>} />
            <Route path="/change-password" element={<ChangePassword/>} />

            {/* GFM inventory */}
            <Route path="/inventory" element={<Navigate to="/inventory/main" replace />} />
            <Route path="/inventory/:site" element={<Inventory/>} />
            <Route path="/gfm/deliveries/:site" element={<GfmOrderBuilder/>} />
            <Route path="/gfm/deliveries" element={<GfmDeliveries/>} />

            {/* Shared */}
            <Route path="/history" element={<History/>} />
            <Route path="/assets" element={<Assets/>} />
            <Route path="/tickets" element={<Tickets/>} />
            <Route path="/teams" element={<Teams/>} />

            {/* GPM */}
            <Route path="/gpm/inventory" element={<GpmInventory/>} />
            <Route path="/services" element={<Services/>} />
            <Route path="/keys" element={<Keys/>} />
            <Route path="/gpm/history" element={<GpmHistory/>} />
            <Route path="/gpm/deliveries" element={<GpmDeliveries/>} />
            <Route path="/gpm/deliveries/new" element={<GpmScheduleDelivery/>} />

            {/* Fleet */}
            <Route path="/vehicles" element={<Vehicles/>} />
            <Route path="/fleetChecks" element={<FleetChecks/>} /> --- IGNORE ---
            <Route path="/fleetChecksList" element={<FleetChecksList/>} /> --- IGNORE ---

            {/* Admin */}
            <Route path="/admin/users" element={<AdminUsers/>} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </OrgProvider>
  );
}